import { useEffect, useRef, useState } from "react";
import api from "../api";

const quando = (d) => {
  const min = Math.floor((Date.now() - new Date(d)) / 60000);
  if (min < 1) return "agora";
  if (min < 60) return `há ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `há ${h} h`;
  return new Date(d).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
};

export default function SinoAvisos({ onAbrir }) {
  const [dados, setDados] = useState({ naoLidas: 0, itens: [] });
  const [aberto, setAberto] = useState(false);
  const [toast, setToast] = useState(null);
  const ultimo = useRef(null);
  const ref = useRef();

  const carregar = () => {
    if (document.hidden) return;
    api.get("/notificacoes").then((r) => {
      const d = r.data || { naoLidas: 0, itens: [] };
      const topo = d.itens[0];
      if (ultimo.current !== null && topo && String(topo._id) !== ultimo.current && !topo.lida) {
        setToast(topo);
        setTimeout(() => setToast(null), 8000);
      }
      ultimo.current = topo ? String(topo._id) : "";
      setDados(d);
    }).catch(() => {});
  };

  useEffect(() => {
    carregar();
    const t = setInterval(carregar, 30000);
    const vis = () => { if (!document.hidden) carregar(); };
    document.addEventListener("visibilitychange", vis);
    const fora = (e) => { if (ref.current && !ref.current.contains(e.target)) setAberto(false); };
    document.addEventListener("mousedown", fora);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", vis); document.removeEventListener("mousedown", fora); };
  }, []);

  const abrirItem = (n) => {
    if (!n.lida) api.put(`/notificacoes/${n._id}/lida`).then(carregar).catch(() => {});
    setAberto(false); setToast(null);
    if (onAbrir) onAbrir(n);
  };
  const lerTodas = () => api.put("/notificacoes/lidas").then(carregar).catch(() => {});

  return (
    <div ref={ref} style={{ position: "relative", fontFamily: "'Inter',-apple-system,sans-serif" }}>
      <button type="button" onClick={() => setAberto((a) => !a)} title="Notificações"
        style={{ position: "relative", width: 36, height: 36, borderRadius: 10, border: "1px solid #ECEEF2", background: aberto ? "#FFF4EC" : "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#1A1D23" }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" /></svg>
        {dados.naoLidas > 0 && (
          <span style={{ position: "absolute", top: -5, right: -5, minWidth: 18, height: 18, padding: "0 5px", boxSizing: "border-box", borderRadius: 99, background: "#EE6A1A", color: "#fff", fontSize: 11, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", border: "2px solid #fff" }}>
            {dados.naoLidas > 99 ? "99+" : dados.naoLidas}
          </span>
        )}
      </button>

      {aberto && (
        <div style={{ position: "absolute", top: 44, right: 0, width: 340, maxWidth: "calc(100vw - 24px)", background: "#fff", border: "1px solid #ECEEF2", borderRadius: 14, boxShadow: "0 16px 40px rgba(0,0,0,.12)", zIndex: 1000, overflow: "hidden" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderBottom: "1px solid #ECEEF2" }}>
            <strong style={{ fontSize: 14, color: "#1A1D23" }}>Notificações</strong>
            {dados.naoLidas > 0 && <button type="button" onClick={lerTodas} style={{ background: "none", border: "none", color: "#EE6A1A", fontSize: 12, fontWeight: 600, cursor: "pointer", padding: 0 }}>Marcar todas como lidas</button>}
          </div>
          <div style={{ maxHeight: 360, overflowY: "auto" }}>
            {dados.itens.length === 0 && <div style={{ padding: 24, textAlign: "center", fontSize: 13, color: "#9499A5" }}>Nenhuma notificação por aqui.</div>}
            {dados.itens.map((n) => (
              <div key={n._id} onClick={() => abrirItem(n)}
                style={{ display: "flex", gap: 10, padding: "12px 16px", cursor: "pointer", borderBottom: "1px solid #F4F5F7", background: n.lida ? "#fff" : "#FFF7F1" }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", marginTop: 6, flexShrink: 0, background: n.lida ? "transparent" : "#EE6A1A" }} />
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: n.lida ? 500 : 700, color: "#1A1D23" }}>{n.titulo}</div>
                  {n.texto && <div style={{ fontSize: 12, color: "#6B7080", marginTop: 2, whiteSpace: "pre-line" }}>{n.texto}</div>}
                  <div style={{ fontSize: 11, color: "#9499A5", marginTop: 4 }}>{quando(n.createdAt)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {toast && (
        <div onClick={() => abrirItem(toast)} style={{ position: "fixed", top: 64, right: 20, zIndex: 2000, width: 320, maxWidth: "calc(100vw - 40px)", background: "#1A1D23", color: "#fff", borderRadius: 14, padding: "14px 16px", boxShadow: "0 16px 40px rgba(0,0,0,.25)", cursor: "pointer", borderLeft: "4px solid #EE6A1A" }}>
          <div style={{ fontSize: 12, color: "#EE6A1A", fontWeight: 700, marginBottom: 4 }}>NOVO LEAD</div>
          <div style={{ fontSize: 14, fontWeight: 700 }}>{toast.titulo}</div>
          {toast.texto && <div style={{ fontSize: 12, color: "#C9CCD3", marginTop: 4, whiteSpace: "pre-line" }}>{toast.texto}</div>}
        </div>
      )}
    </div>
  );
}
